import { ITransactionDetailsOtt, ITransactionDetailsOrder, ITransactionDetailsPayment, ITransactionDetailsTransaction } from "./types";

export default class TransactionDetailsOtt implements ITransactionDetailsOtt {

  order: ITransactionDetailsOrder;
  payment: ITransactionDetailsPayment;
  transaction: ITransactionDetailsTransaction | null;


  constructor(order: ITransactionDetailsOrder, payment: ITransactionDetailsPayment, transaction: ITransactionDetailsTransaction | null) {
    this.order = order;
    this.payment = payment;
    this.transaction = transaction;
  }

}
